import { useState } from 'react';
import { Copy, Check } from '@phosphor-icons/react';
import styles from './Form.module.css';

const CopyField = ({ label, value }: { label: string; value: string }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className={styles.credentialField}>
            <span className={styles.credentialLabel}>{label}</span>
            <div className={styles.credentialValue}>
                <code className={styles.credentialCode}>{value}</code>
                <button
                    type="button"
                    className={styles.copyButton}
                    onClick={handleCopy}
                    aria-label={`Copy ${label}`}
                >
                    {copied ? <Check size={14} weight="bold" /> : <Copy size={14} />}
                </button>
            </div>
        </div>
    );
};

export default CopyField;
